import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';

const dynamicVisnavCarouselItemClass = dt([
    'inline-flex',
    'flex-shrink-0',
    'w-[112px]',
    'smMd:last:w-[136px]',
    'smMd:last:pr-6',
]);

const dynamicVisnavCarouselContainerClass = dt([
    'sm:overflow-scroll',
    'sm:mr-6',
    'lg:overflow:hidden',
    'lg:justify-center',
]);

const dynamicCarouselDivContainerClass = dt([
    'smMd:mx-6',
    'sm:gap-x-4',
    'md:gap-x-6',
    'lg:gap-x-4',
    'md:justify-between',
]);

const leftArrowClass = dt(['sm:hidden', 'lg:block', 'float-left']);

const rightArrowClass = dt(['sm:hidden', 'lg:block', 'float-right']);

const carouselTheme = {
    carousel: {
        carouselItem: dt([
            'lg:w-[22.5%]',
            'md:w-[27.5%]',
            'sm:w-[42.5%]',
            'inline-flex',
            'flex-shrink-0',
        ]),
        carouselContainer: dt(['sm:overflow-scroll', 'lg:overflow:hidden']),
        leftArrow: leftArrowClass,
        rightArrow: rightArrowClass,
    },
    'rrzones-carousel': {
        carouselItem: dt([
            'lg:w-[12.3%]',
            'md:w-[19.4%]',
            'sm:w-[42.8%]',
            'flex-shrink-0',
            'sm:pr-3',
        ]),
        carouselContainer: dt(['sm:overflow-scroll', 'lg:overflow:hidden', 'lg:padding:5px']),
        leftArrow: leftArrowClass,
        rightArrow: rightArrowClass,
    },
    'cart-carousel': {
        carouselItem: dt([
            'lg:w-[12.3%]',
            'md:w-[19.4%]',
            'sm:w-[42.8%]',
            'flex-shrink-0',
            'sm:pr-3',
        ]),
        carouselContainer: dt(['sm:overflow-scroll', 'lg:overflow:hidden', 'lg:padding:5px']),
        leftArrow: leftArrowClass,
        rightArrow: rightArrowClass,
    },
    'inslider-carousel': {
        carouselItem: dt(['lg:w-[28%]', 'sm:w-[42.8%]', 'flex-shrink-0', 'sm:pr-3']),
        carouselContainer: dt(['sm:overflow-scroll', 'lg:overflow:hidden', 'lg:padding:5px']),
        leftArrow: leftArrowClass,
        rightArrow: rightArrowClass,
    },
    'hotdeals-carousel': {
        carouselItem: dt([
            'lg:w-[15.5%]',
            'md:w-[19.4%]',
            'sm:w-[42.8%]',
            'flex-shrink-0',
            'sm:pr-3',
        ]),
        carouselContainer: dt(['sm:overflow-scroll', 'lg:overflow:hidden', 'lg:padding:5px']),
        leftArrow: leftArrowClass,
        rightArrow: rightArrowClass,
    },
    'nucleus-carousel': {
        carouselItem: dt([
            'lg:w-[22.5%]',
            'md:w-[27.5%]',
            'sm:w-[42.5%]',
            'inline-flex',
            'flex-shrink-0',
        ]),
        carouselContainer: dt(['sm:overflow-scroll', 'lg:overflow:hidden', 'lg:mx-6']),
        leftArrow: leftArrowClass,
        rightArrow: rightArrowClass,
    },
    'viz-nav-carousel': {
        carouselItem: dt([
            'lg:w-[16%]',
            'md:w-[16.34%]',
            'sm:w-[30%]',
            'inline-flex',
            'flex-shrink-0',
        ]),
        carouselContainer: dt(['sm:overflow-scroll', 'lg:overflow:hidden']),
        leftArrow: leftArrowClass,
        rightArrow: rightArrowClass,
    },
    'dynamic-rel-visNav-carousel': {
        carouselItem: dynamicVisnavCarouselItemClass,
        carouselContainer: dynamicVisnavCarouselContainerClass,
        carouselDivContainer: dynamicCarouselDivContainerClass,
        leftArrow: leftArrowClass,
        rightArrow: rightArrowClass,
    },
    'dyanmic-rel-visNav-carousel-even': {
        carouselItem: `${dynamicVisnavCarouselItemClass} ${dt([
            'smMd:last:w-[112px]',
            'smMd:last:pr-0',
        ])}`,
        carouselContainer: dynamicVisnavCarouselContainerClass,
        carouselDivContainer: dynamicCarouselDivContainerClass,
        leftArrow: leftArrowClass,
        rightArrow: rightArrowClass,
    },
    'dynamic-rel-visNav-carousel-center': {
        carouselItem: `${dynamicVisnavCarouselItemClass} ${dt([
            'smMd:last:w-[112px]',
            'smMd:last:pr-0',
        ])}`,
        carouselContainer: dynamicVisnavCarouselContainerClass,
        carouselDivContainer: dt(['sm:mx-6', 'md:justify-center', 'md:gap-x-10']),
        leftArrow: leftArrowClass,
        rightArrow: rightArrowClass,
    },
};

export default carouselTheme;
